export default __webpack_public_path__ + "static/media/icon-social.64be0c18.svg";